export const default_margin = 'dense';
